import * as angular from "angular";
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {ConsolidatedCommissionsService} from "../../services/consolidated-commissions-service.service";
import {ConsolidatedCommissionModel} from "../../models/consolidated-commission.model";
import {CommissionPaymentDetailsModel} from "../../models/commission-payment-details.model";
import {CommissionModel} from "../../models/commission.model";
import {
  ExportConsolidatedCommissionsTranslationsPayloadModel
} from "../../types/export-consolidated-commissions-translations-payload.model";
import {CommissionsDialogService} from "../../services/commissions-dialogs-service.service";
import {CommissionsService} from "../../services/commissions-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class ConsolidatedCommissionViewCtrl implements IController {

  consolidatedCommission: ConsolidatedCommissionModel;
  onBack?: Function;

  public commissionsRef: any;
  public commissionsIds: string[];
  public selectedCommissionsIds: string[] = [];
  public selectedTotals: any;

  constructor(private splitService, private $commission,
              private $log: ILogService,
              private commissionsDialogService: CommissionsDialogService, private confirmDialogService: ConfirmDialogService, private commissionsService: CommissionsService, private $translate,
              private consolidatedCommissionsService: ConsolidatedCommissionsService) {
    this.commissionsRef = $commission();
  }

  $onInit() {
    this._refreshCommissions();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.consolidatedCommission && !changes.consolidatedCommission.isFirstChange()) {
      const currentConsolidatedCommission = changes.consolidatedCommission.currentValue;
      const previousConsolidatedCommission = changes.consolidatedCommission.previousValue;

      if (_.get(currentConsolidatedCommission, 'commissionReferences.length') !== _.get(previousConsolidatedCommission, 'commissionReferences.length')) {
        this._refreshCommissions();
      }
    }
  }

  onEditConsolidatedCommission() {
    this.commissionsDialogService.editConsolidateCommission(this.consolidatedCommission)
      .then((editedConsolidatedCommission) => {
        this._updateConsolidatedCommission(this.consolidatedCommission.id, editedConsolidatedCommission);
      })
  }

  onMarkAsPaid() {
    this.commissionsDialogService.payManually(this.consolidatedCommission.name, this.consolidatedCommission.paymentDetails , this.consolidatedCommission.totalCommission)
      .then((commissionPaymentDetails: CommissionPaymentDetailsModel) => {
        this._markAsPaid(commissionPaymentDetails);
      })
  }

  onPay() {
    this.commissionsDialogService.payManually(this.consolidatedCommission.name, this.consolidatedCommission.paymentDetails, this.consolidatedCommission.totalCommission)
      .then((commissionPaymentDetails: CommissionPaymentDetailsModel) => {
        this._pay(this.consolidatedCommission.id, commissionPaymentDetails);
      })
  }

  onAttachFile() {
    this.commissionsDialogService.attachFile(this.consolidatedCommission.name, this.consolidatedCommission.paymentDetails)
      .then((commissionPaymentDetails: CommissionPaymentDetailsModel) => {
        const consolidatedToUpdate = angular.copy(this.consolidatedCommission);
        consolidatedToUpdate.paymentDetails = commissionPaymentDetails;

        this._updateConsolidatedCommission(this.consolidatedCommission.id, consolidatedToUpdate);
      })
  }

  onAddAFee($event) {
    this.commissionsDialogService.addFee($event)
      .then((payload) => {
        if (payload.feeType === 'Credit') {
          const attachments = payload.attachment ? [payload.attachment] : undefined;
          const descriptions = payload.description ? [payload.description] : undefined;
          this._addCredit(payload.amount, payload.isAssistant, payload.date, attachments, descriptions);
        }
        if (payload.feeType === 'Debt') {
          const attachments = payload.attachment ? [payload.attachment] : undefined;
          const descriptions = payload.description ? [payload.description] : undefined;
          this._addDebt(payload.amount, payload.isAssistant, payload.date, attachments, descriptions);
        }
      })
  }

  onAddCommissions() {
    this.commissionsDialogService.addCommissionsToConsolidatedOrder(this.consolidatedCommission.accountReference.id)
      .then((commissionsIdsToAdd) => {
        const payload = {
          commissionIds: commissionsIdsToAdd
        }
        this._addCommissions(payload);
      })
  }

  onRemoveCommission(commission, $event) {
    const text = 'Are you sure you want to remove this commission?';
    this.confirmDialogService.confirm('Remove Commission From Consolidated Commission', text, $event)
      .then(() => {
        this._removeCommissions([commission.id]);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onRemoveCommissions(commissionsIds, $event) {
    const text = 'Are you sure you want to remove these commissions?';
    this.confirmDialogService.confirm('Remove Commissions From Consolidated Commission', text, $event)
      .then(() => {
        this._removeCommissions(commissionsIds);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onExportCSV() {
    const zoneId = this.splitService.getTimeZone();
    const payload: ExportConsolidatedCommissionsTranslationsPayloadModel = this._getExportPayload();
    this.consolidatedCommissionsService.exportCSV(this.consolidatedCommission.id, payload, zoneId);
  }

  onClearSelected() {
    this.selectedCommissionsIds = [];
  }

  onOpenActions($mdMenu) {
    $mdMenu.open();
  }

  onEditPrice(commission: CommissionModel) {
    this.commissionsDialogService.editPrice()
      .then((payload) => {
        this._editPrice(commission.id, payload.price, payload.comment);
      })
  }

  onSelectedCommissionIdsChange(selectedIds) {
    this.selectedCommissionsIds = selectedIds;
    this._setSelectedTotals(this.selectedCommissionsIds);
  }

  private _getCommissionsByIds(ids) {
    return this.commissionsRef.$asyncValues(ids);
  }

  private _setSelectedTotals(ids) {

    if (!ids?.length) {
      this.selectedTotals = undefined;
    }

    this._getCommissionsByIds(ids)
      .then((commissions) => {
        this.selectedTotals = {
          currencyCode: _.get(commissions, '[0].currencyCode'),
          amount: _.sumBy(commissions, 'commission')
        }
      })
  }

  private _editPrice(commissionId, price, comment) {
    this.commissionsService.editPrice(commissionId, price, comment)
      .then(() => {
        this._refreshCommissions();
      })
  }

  private _updateConsolidatedCommission(consolidatedCommissionId, consolidatedCommission: ConsolidatedCommissionModel) {
    this.consolidatedCommissionsService.update(consolidatedCommissionId, consolidatedCommission)
      .then((updatedConsolidatedCommission) => {
        this.consolidatedCommission = updatedConsolidatedCommission;
        this._refreshCommissions();
      })
  }

  private _markAsPaid(commissionPaymentDetails: CommissionPaymentDetailsModel) {
    this.consolidatedCommissionsService.payManually(this.consolidatedCommission.id, commissionPaymentDetails)
      .then((updatedConsolidatedCommission) => {
        this.consolidatedCommission = updatedConsolidatedCommission;
        this._refreshCommissions();
      })
  }

  private _pay(consolidatedCommissionId, commissionPaymentDetails: CommissionPaymentDetailsModel) {
    this.consolidatedCommissionsService.pay(consolidatedCommissionId, commissionPaymentDetails)
      .then((updatedConsolidatedCommission) => {
        this.consolidatedCommission = updatedConsolidatedCommission;
        this._refreshCommissions();
      })
  }

  private _getConsolidatedCommission() {
    this.consolidatedCommissionsService.getOne(this.consolidatedCommission.id)
      .then((updatedConsolidatedCommission) => {
        this.consolidatedCommission = updatedConsolidatedCommission;
      })
  }

  private _addCredit(commission, isAssistant, date, attachments?, descriptions?) {
    const payload = {
      accountId: this.consolidatedCommission.accountReference.id,
      agentId: undefined,
      serviceId: undefined,
      consolidatedCommissionId: this.consolidatedCommission.id,
      descriptions: descriptions,
      isAssistant: isAssistant,
      commissionDate: date,
      commissionMethodType: undefined,
      commission: commission,
      attachments: attachments
    }

    this.commissionsService.addCredit(payload)
      .then((commission) => {

      })
  }

  private _addDebt(commission, isAssistant, date, attachments?, descriptions?) {
    const payload = {
      accountId: this.consolidatedCommission.accountReference.id,
      agentId: undefined,
      serviceId: undefined,
      consolidatedCommissionId: this.consolidatedCommission.id,
      descriptions: descriptions,
      isAssistant: isAssistant,
      commissionDate: date,
      commissionMethodType: undefined,
      commission: commission,
      attachments: attachments
    }
    this.commissionsService.addDebt(payload)
      .then((commission) => {

      })
  }

  private _addCommissions(payload) {
    this.consolidatedCommissionsService.addCommissions(this.consolidatedCommission.id, payload)
      .then((updatedConsolidatedCommission) => {
        this.consolidatedCommission = updatedConsolidatedCommission;
        // this._refreshCommissions();
      })
  }

  private _removeCommissions(commissionsIds) {
    this.consolidatedCommissionsService.removeCommissions(this.consolidatedCommission.id, commissionsIds)
      .then((updatedConsolidatedCommission) => {
        this.consolidatedCommission = updatedConsolidatedCommission;
        // this._refreshCommissions();
      })
  }

  private _refreshCommissions() {
    this.onClearSelected();
    this.commissionsIds = _.map(this.consolidatedCommission.commissionReferences, 'id');
  }

  private _getExportPayload(): ExportConsolidatedCommissionsTranslationsPayloadModel {
    return {
      accountName: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.accountName'),
      packageBarcodes:this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.packageBarcodes'),
      packageNames: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.packageNames'),
      agentId: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.agentId'),
      agentName: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.agentName'),
      serviceId: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.serviceId'),
      serviceExternalId: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.serviceExternalId'),
      createdAt: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.createdAt'),
      updatedAt: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.updatedAt'),
      pickupAddress: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.pickupAddress'),
      dropoffAddress: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.dropoffAddress'),
      timeWindow: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.timeWindow'),
      paymentType: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.paymentType'),
      amount: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.amount'),
      manualAmount: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.manualAmount'),
      servicePrice: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.servicePrice'),
      paymentAdditionalInfo: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.paymentAdditionalInfo'),
      paidDate: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.paidDate'),
      madeBy: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.madeBy'),
      paidManually: this.$translate.instant('EXPORT_CONSOLIDATED_COMMISSION_COLUMNS.paidManually')
    }
  }

}

angular
  .module('bringoz.admin.commissions')
  .component('consolidatedCommissionView', {
    bindings: {
      consolidatedCommission: '<',
      onBack: '&'
    },
    template: require('./consolidated-commission-view.html').default,
    controller: ConsolidatedCommissionViewCtrl
  });
